// extracted by mini-css-extract-plugin
export default {"quiz_question":"rZ","question_subheader":"sZ","why_popup":"tZ","why_underline":"uZ","MyClassEnterDone":"vZ","WhyAskEnterDone":"wZ","WhyUnderlineEnterDone":"xZ","main_question":"yZ"};
    if(module.hot) {
      // 1711717535086
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  